import { render } from "./AlexandraIoanaNastasaPage.vue?vue&type=template&id=3c67d7af"
import script from "./AlexandraIoanaNastasaPage.vue?vue&type=script&lang=js"
export * from "./AlexandraIoanaNastasaPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__